/**
@ngdoc directive
@name activitiesCount

@description
Fetch the activitiesCount from server.<br/>
 Display the last-count/lastCount collected from DB stored in session.</br/>
 IF time-passed-in-millis/timePassedInMillis is greater than the refresh-time-in-millis/refreshTimeInMillis</br/>
 Normally after 4 minutes</br/>
 THEN collect an up to date count via http://localhost:8080/activityCentre/activityCount .</br/>
 IF http://localhost:8080/activityCentre/list always collects an up to date count</br/>

In case failed to connect to server, no need in trying to make further connection.

 @param {number} refresh-time-in-millis/refreshTimeInMillis ~ refresh time intervals before collecting a new count via service.
*/

(function () {
  "use strict";

  // you may declare your data structure / objects outside of the directive ie. in here

  let activitiesCount = function (ajaxCall, $interval, $timeout) {
    // or ajaxCall
    return {
      scope: true,
      bindToController: {
        /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
        refreshTimeInMillis: '<',
        debug: '<'
      },
      controller: [
        "$scope",
        "$element",
        "$attrs",
        function ($scope, $element, $attrs) {
          const _this = this;
          const XHR_URL = WEBAPP_PATH + "/activityTask/activityCount";
          const CALL_LIMIT_TIME_MILLIS = (12 * 60 * 1000); //12 mins e.g. 3 calls then times out
          const DEFAULT_REFRESH_TIME_MILLIS = (4 * 60 * 1000); //4 mins See ActivitiesCount.REFRESH_IN_TIME_MILLIS
          const RESTART_WAIT_TIME_MILLIS = (5 * 1000); //5 seconds
          const HTTP_STATUS_FOUND = 302;
          let REFRESH_TIME_MILLIS;
          let CALL_LIMIT;
          let callsNum = 0;
          let intervalPromise;
          let timeoutPromise;
          let $document;
          let restarting = false;
          $scope.connectionProblem = false;
          $scope.activitiesNumber = 0;

          let debugIt = function (methodName, content) {
            if (_this.debug === undefined) _this.debug = false; //Switch this value or the directive argument to true, to see realtime console log calls
            if (_this.debug) console.log('activitiesCount.' + methodName, content);
          }

          /**
           * initialisation method
           */
          this.$onInit = function () {
            debugIt('$onInit');
            //Server side value as driven by session cache
            REFRESH_TIME_MILLIS = _this.refreshTimeInMillis===undefined ? DEFAULT_REFRESH_TIME_MILLIS : _this.refreshTimeInMillis ; // Usually 4 mins
            CALL_LIMIT = CALL_LIMIT_TIME_MILLIS / REFRESH_TIME_MILLIS; // Not allowed to call after 1 hour
            // In case you need to debug
            // console.log({XHR_URL, REFRESH_TIME_MILLIS, CALL_LIMIT});
            startUpdates();
            calculateTextColour();
          };

          let actionFromUserRestartUpdates = function () {
            //Post IE11 switch to literal {restarting}
            debugIt('actionFromUserRestartUpdates', {restarting: restarting});
            if(!restarting) {
              restarting = true;
              //immediately after a move remove mouse move event
              $document.off("mousemove", actionFromUserRestartUpdates);
              callsNum = 0;
              //Wait X minutes before restarting to avoid loop calls of start, fail, bind,
              timeoutPromise = $timeout(
                  startUpdates,
                  RESTART_WAIT_TIME_MILLIS
              );
            }
          };

          /**
           * Restart activity XHR calls.
           * Bind a mousemove listener, which will run handler()
           * handler() restarts the fetchCount() and unbinds the mouse move operation
           * This is NOT mobile friendly
           */
          let pauseAndWaitForActionFromUser = function () {
            debugIt('pauseAndWaitForActionFromUser');
            if (!$document) $document = $(document);
            $document.on("mousemove", actionFromUserRestartUpdates);
          };

          /**
           * Stop updates after 1 hours worth of calls
           */
          let checkIfUpdateLimitReached = function () {
            //Post IE11 switch to literal {callsNum, CALL_LIMIT}
            debugIt('checkIfUpdateLimitReached',{callsNum: callsNum, CALL_LIMIT: CALL_LIMIT});
            if (callsNum > CALL_LIMIT) {
              stopUpdates();
              return;
            }
            callsNum++;
          };

          /**
           * Call straight away, then perform calls in intervals.
           * Intervals spaced at 4 minutes according to server side cache value.
           * If called more frequently will obtain a cache value
           */
          let startUpdates = function () {
            debugIt('startUpdates');
            getUpdate(); //call straight away
            if(!intervalPromise) {
              intervalPromise = $interval(getUpdate, REFRESH_TIME_MILLIS);
            }
            restarting = false;
          };

          let cancelUpdateIntervals = function () {
            debugIt('cancelUpdateIntervals');
            $interval.cancel(intervalPromise);
            intervalPromise = null;
          };

          /**
           * Cancel the promises
           */
          let stopUpdates = function () {
            debugIt('stopUpdates');
            cancelUpdateIntervals();
            $scope.connectionProblem = true;
            pauseAndWaitForActionFromUser();
          }

          /**
           * Perform a server update calling XHR_URL (/activityTask/activityCount)
           */
          let getUpdate = function () {
            debugIt('getUpdate');
            checkIfUpdateLimitReached();
            ajaxCall.getData(XHR_URL).then(
              function (result) {
                // Session timed out and redirecting to login
                if (result.status !== HTTP_STATUS_FOUND) {
                  // Example result.data : {"activitiesCount":{"cacheAgeInSeconds":41,"cacheTimeLeftInSeconds":199,"count":394,"lastUpdatedOn":"2023-09-04T17:48:59.059Z","isCacheStale":false}}
                  $scope.activitiesNumber = result.data.activitiesCount.count;
                  $scope.connectionProblem = false;
                } else {
                  stopUpdates();
                }
              },
              function (result) {
                stopUpdates();
              }
            );
          };

          let calculateTextColour = function () {
            debugIt('calculateTextColour');
            const activityIcon = document.getElementById("activityIcon");
            const style = window.getComputedStyle(activityIcon, null);

            setTimeout(function () { // required to access ng-if controlled component
              const activityNumber = angular.element("#activityWrapper");
              activityNumber[0].style.color = getContrastingTextColour(
                style.getPropertyValue("color"),
                "#ffffff",
                "#000000"
              );
            }, 0);
          };

          let getContrastingTextColour = function (
            bgColour,
            lightColour,
            darkColour
          ) {
            debugIt('getContrastingTextColour');
            let colour, r, g, b;
            if (bgColour.charAt(0) === "#") {
              // is a hex value
              colour = bgColour.substring(1, 7);
              r = parseInt(colour.substring(0, 2), 16); // hexToR
              g = parseInt(colour.substring(2, 4), 16); // hexToG
              b = parseInt(colour.substring(4, 6), 16); // hexToB
            } else if (bgColour.substring(0, 3) === "rgb") {
              // rgb value provided with rgb prefix
              colour = bgColour.substring(4, 17).split(", "); // remove rgb prefix and create array with individual colour values
              r = colour[0];
              g = colour[1];
              b = colour[2];
            }
            return r * 0.299 + g * 0.587 + b * 0.114 > 186
              ? darkColour
              : lightColour;
          };

          $scope.$on('$destroy', function() {
            cancelUpdateIntervals();
          });
        },
      ],

      controllerAs: "ctrl",
      restrict: "E", // so it's used as <activities-count></activities-count> in the count
      replace: true, // you probably want to replace the whole <activities-count> element with the template
      transclude: false,
      templateUrl:
        WEBAPP_PATH + "/js/angular/src/components/widget/activitiesCount.html",
    };
  };
  activitiesCount.$inject = ["ajaxCall", "$interval", "$timeout"];
  angular.module("app").directive("activitiesCount", activitiesCount);
})();
